import React, { useState } from "react";
import "../../../styles/Containers.css";
import "../../../styles/Colors.css";
import "../../../styles/Fonts.css";
import "../styles/AddRecipeCardStyle.css";

const TagsForm = ({ tags, setTags, inputClass }) => {
  const [tagInput, setTagInput] = useState("");

  const handleTagInputChange = (event) => {
    setTagInput(event.target.value);
  };

  const handleTagInputKeyDown = (event) => {
    if (event.key === "Enter" && tagInput !== "") {
      setTags([...tags, tagInput]);
      setTagInput("");
    }
  };

  const handleAddTag = () => {
    if (tagInput !== "") {
      setTags([...tags, tagInput]);
      setTagInput("");
    }
  };

  const handleTagDelete = (tag) => {
    const updatedTags = tags.filter((t) => t !== tag);
    setTags(updatedTags);
  };

  return (
    <div>
      <div className="spc-between">
        <input
          type="text"
          placeholder="اینجا بنویس..."
          value={tagInput}
          onChange={handleTagInputChange}
          onKeyDown={handleTagInputKeyDown}
          className={inputClass}
        />
        <button type="button" onClick={handleAddTag} className="addTag width20">
          <div className="marginTop10">
            <span className="icon-iconplus heading-2"></span>
          </div>
        </button>
      </div>

      <div className="flex-wrap">
        {tags.map((tag) => (
          <div key={tag} className="tagBox">
            {tag}
            <button
              type="button"
              onClick={() => handleTagDelete(tag)}
              className="tagClose"
            >
              <div className="marginTop20">
                <span className="icon-iconclose subject-1"></span>
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TagsForm;
